module.exports = __webpack_public_path__ + "img/avatar4.39c4c385.png";